import { getActorInfo } from "../../utils/onBehalf";
import { formatDate } from "./constants";

const toTime = (value) => {
  if (!value) return null;
  const time = new Date(value).getTime();
  return Number.isNaN(time) ? null : time;
};

const latestUpload = (documents) =>
  (documents || [])
    .map((doc) => doc?.uploadedDate)
    .filter((value) => toTime(value) !== null)
    .sort((a, b) => toTime(b) - toTime(a))[0] || null;

// Who did what on a resignation, oldest first. Each step shows only when the
// record carries its date; the "by" line shows only when the backend returned an
// actor, so records saved before the audit fields existed list dates alone.
const ResignationActivity = ({ record, viewer = "admin" }) => {
  if (!record) return null;

  const actorFor = (prefix) =>
    record[`${prefix}By`]
      ? getActorInfo({
          actorId: record[`${prefix}By`],
          actorName: record[`${prefix}ByName`],
          actorRole: record[`${prefix}ByRole`],
          ownerId: record.employeeId,
          ownerName: record.employeeName,
        })
      : null;

  const steps = [
    { key: "submitted", label: "Resignation submitted", at: record.submittedDate, actor: actorFor("submitted") },
    { key: "approved", label: "Approved by HR", at: record.approvedDate, actor: null },
    {
      key: "uploaded",
      label: "Exit documents uploaded",
      at: record.documentsUploadedOn || latestUpload(record.documents),
      actor: actorFor("documentsUploaded"),
    },
    { key: "reviewed", label: "Exit documents reviewed", at: record.reviewedDocumentsDate, actor: null },
    { key: "withdrawn", label: "Resignation withdrawn", at: record.withdrawnOn, actor: actorFor("withdrawn") },
  ]
    .filter((step) => toTime(step.at) !== null)
    .sort((a, b) => toTime(a.at) - toTime(b.at));

  if (!steps.length) return null;

  const ownerText =
    viewer === "employee" ? "on your behalf" : `on behalf of ${record.employeeName || "the employee"}`;

  return (
    <div className="mt-5 border-t border-gray-100 pt-4">
      <h3 className="text-sm font-semibold text-gray-700">Activity</h3>
      <ol className="mt-3 space-y-3">
        {steps.map((step) => (
          <li key={step.key} className="flex gap-3">
            <span className="mt-1.5 h-2 w-2 shrink-0 rounded-full bg-blue-primary" />
            <div>
              <p className="text-sm text-gray-700">
                {step.label}
                <span className="text-gray-400"> &middot; {formatDate(step.at, true)}</span>
                {step.actor?.isOnBehalf && (
                  <span className="ml-2 rounded-full border border-blue-300 bg-blue-100 px-2 py-0.5 text-xs font-semibold text-blue-700">
                    On behalf
                  </span>
                )}
              </p>
              {step.actor?.actorName && (
                <p className="text-xs text-gray-500">
                  by {step.actor.actorName}
                  {step.actor.roleLabel ? ` (${step.actor.roleLabel})` : ""}
                  {step.actor.isOnBehalf ? ` ${ownerText}` : ""}
                </p>
              )}
            </div>
          </li>
        ))}
      </ol>
    </div>
  );
};

export default ResignationActivity;
